/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMathXDivideY = createReactComponent("outline", "math-x-divide-y", "IconMathXDivideY", [["path", { "d": "M9 3l6 6", "key": "svg-0" }], ["path", { "d": "M9 9l6 -6", "key": "svg-1" }], ["path", { "d": "M9 15l3 4.5", "key": "svg-2" }], ["path", { "d": "M15 15l-4.5 7", "key": "svg-3" }], ["path", { "d": "M5 12h14", "key": "svg-4" }]]);

export { IconMathXDivideY as default };
//# sourceMappingURL=IconMathXDivideY.mjs.map
